var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { IdResource } from "../../constants/IdResource";
import { TabCoopChat } from "../chat/TabCoopChat";
import { TabCoopFoundEdit } from "../cooperative/found-edit/TabCoopFoundEdit";
import { IdCoopCategory } from "../cooperative/IdCoopCategory";
import { TabCoopProjects } from "../cooperative/projects/TabCoopProjects";
import { TabCoopHelp } from "../cooperative/TabCoopHelp";
import { TabCoopInfoView } from "../cooperative/TabCoopInfoView";
import { TabCoopMessageBoard } from "../cooperative/TabCoopMessageBoard";
import { TabCoopSearch } from "../cooperative/TabCoopSearch";
import { DoghouseCategory } from "../doghouse/DoghouseCategory";
import { TabDoghousePremium } from "../doghouse/TabDoghousePremium";
import { TabDoghouseStandard } from "../doghouse/TabDoghouseStandard";
import { IdExternalBarnCategory } from "../external-barn/IdExternalBarnCategory";
import { TabUpgradeExternalBarn } from "../external-barn/TabUpgradeExternalBarn";
import { FarmManagementCategory } from "../farm-management/FarmManagementCategory";
import { TabProducts } from "../farm-management/TabProducts";
import { MasterViewAdventureQuests } from "../info/quest/list/MasterViewAdventureQuests";
import { MasterViewBaseQuests } from "../info/quest/list/MasterViewBaseQuests";
import { QuestCategory } from "../info/quest/list/QuestCategory";
import { IdLibraryCategory } from "../library/IdLibraryCategory";
import { TabFarm } from "../library/TabFarm";
import { UpgradeLibrary } from "../library/UpgradeLibrary";
import { IdMarketCategory } from "../market/IdMarketCategory";
import { TabImprovements } from "../market/TabImprovements";
import { TabMarket } from "../market/TabMarket";
import { NurseryCategory } from "../nursery/NurseryCategory";
import { TabNursery } from "../nursery/TabNursery";
import { UpgradeNursery } from "../nursery/UpgradeNursery";
import { BuildingCategory } from "../player-base/buildings/BuildingCategory";
import { MasterDetailBuildings } from "../player-base/buildings/MasterDetailBuildings";
import { MasterDetailInventory } from "../player-base/buildings/MasterDetailInventory";
import { PlayerRankingCategory } from "../ranking/PlayerRankingCategory";
import { TabRanking } from "../ranking/TabRanking";
import { MenuSettingsCategory } from "../settings/MenuSettingsCategory";
import { TabBlog } from "../settings/TabBlog";
import { TabSettings } from "../settings/TabSettings";
import { IdStoreCategory } from "../store/IdStoreCategory";
import { TabStoreItems } from "../store/TabStoreItems";
import { TabThemedEvent } from "../themed-events/TabThemedEvent";
import { ThemedEventCateogry } from "../themed-events/ThemedEventCategory";
import { IdCollectCategory } from "../tournament-building/IdCollectCategory";
import { IdTournamentCategory } from "../tournament-building/IdTournamentCategory";
import { LeagueInfo } from "../tournament-building/LeagueInfo";
import { TabCoopLeague } from "../tournament-building/TabCoopLeague";
import { TabLeaguesOverview } from "../tournament-building/TabLeaguesOverview";
import { TabPlayerLeague } from "../tournament-building/TabPlayerLeague";
import { TabTournamentRanking } from "../tournament-building/TabTournamentRanking";
import { TabWaterTower } from "../watertower/TabWaterTower";
import { UpgradeWaterTower } from "../watertower/UpgradeWaterTower";
import { WaterTowerCategory } from "../watertower/WaterTowerCategory";
export var menuTabs = (_a = {},
    _a[IdMenuBalancing.Market] = {
        categories: (_b = {},
            _b[IdMarketCategory.Main] = {
                domComponent: TabMarket,
            },
            // TODO: Implement Market Adventure component
            _b[IdMarketCategory.Adventure] = {
                // tslint:disable-next-line:no-null-keyword
                domComponent: function () { return null; },
            },
            _b[IdMarketCategory.Improvement] = {
                domComponent: TabImprovements,
            },
            _b),
    },
    _a[IdMenuBalancing.Build] = {
        categories: (_c = {},
            _c[BuildingCategory.Facilities] = {
                domComponent: MasterDetailBuildings,
                footerResources: [IdResource.Money, IdResource.Gold],
            },
            _c[BuildingCategory.Decorations] = {
                domComponent: MasterDetailBuildings,
                footerResources: [IdResource.Money, IdResource.Gold],
            },
            _c[BuildingCategory.SpecialBuildings] = {
                domComponent: MasterDetailBuildings,
                footerResources: [
                    IdResource.ChestKeys,
                    IdResource.PawPrints,
                    IdResource.BuildCoupons,
                    IdResource.AdventureCoins,
                ],
            },
            _c[BuildingCategory.SpecialDecorations] = {
                domComponent: MasterDetailBuildings,
                footerResources: [IdResource.DecoCoupons, IdResource.SpecialCoupons],
            },
            _c[BuildingCategory.Stored] = {
                domComponent: MasterDetailInventory,
                footerResources: [IdResource.Money, IdResource.Gold],
            },
            _c),
    },
    _a[IdMenuBalancing.Quest] = {
        categories: (_d = {},
            _d[QuestCategory.Main] = {
                domComponent: MasterViewBaseQuests,
            },
            _d[QuestCategory.Adventure] = {
                domComponent: MasterViewAdventureQuests,
            },
            _d),
    },
    _a[IdMenuBalancing.WaterTower] = {
        categories: (_e = {},
            _e[WaterTowerCategory.Main] = {
                domComponent: TabWaterTower,
            },
            _e[WaterTowerCategory.Upgrade] = {
                domComponent: UpgradeWaterTower,
            },
            _e),
    },
    _a[IdMenuBalancing.Nursery] = {
        categories: (_f = {},
            _f[NurseryCategory.Main] = {
                domComponent: TabNursery,
            },
            _f[NurseryCategory.Upgrade] = {
                domComponent: UpgradeNursery,
            },
            _f),
    },
    _a[IdMenuBalancing.DogHouse] = {
        categories: (_g = {},
            _g[DoghouseCategory.GiveDoghouseBone] = {
                domComponent: TabDoghouseStandard,
            },
            _g[DoghouseCategory.GiveDoghouseBonePrm] = {
                domComponent: TabDoghousePremium,
            },
            _g),
    },
    _a[IdMenuBalancing.FarmManagement] = {
        categories: (_h = {},
            _h[FarmManagementCategory.Products] = {
                domComponent: TabProducts,
            },
            _h[FarmManagementCategory.FarmSupplies] = {
                domComponent: TabProducts,
            },
            _h[FarmManagementCategory.Materials] = {
                domComponent: TabProducts,
            },
            _h),
    },
    _a[IdMenuBalancing.Tournament] = {
        categories: (_j = {},
            _j[IdTournamentCategory.PlayerLeague] = {
                domComponent: TabPlayerLeague,
            },
            _j[IdTournamentCategory.CoopLeague] = {
                domComponent: TabCoopLeague,
            },
            _j[IdTournamentCategory.LeagueRanking] = {
                domComponent: TabTournamentRanking,
            },
            _j[IdTournamentCategory.LeagueOverview] = {
                domComponent: TabLeaguesOverview,
            },
            _j),
    },
    _a[IdMenuBalancing.CollectMenu] = {
        categories: (_k = {},
            _k[IdCollectCategory.CollectLeague] = {
                // the name does not start with "TAB", but it would be odd to make a TabLeagueInfo,
                // which only returns leagueInfo.
                domComponent: LeagueInfo,
            },
            _k[IdCollectCategory.LeagueRanking] = {
                domComponent: TabTournamentRanking,
            },
            _k[IdCollectCategory.LeagueOverview] = {
                domComponent: TabLeaguesOverview,
            },
            _k),
    },
    _a[IdMenuBalancing.RankingMenu] = {
        categories: (_l = {},
            _l[PlayerRankingCategory.PlayerLevelRanking] = {
                domComponent: TabRanking,
            },
            _l[PlayerRankingCategory.CoopLevelRanking] = {
                domComponent: TabRanking,
            },
            _l[PlayerRankingCategory.AdventurerLevelRanking] = {
                domComponent: TabRanking,
            },
            _l),
    },
    _a[IdMenuBalancing.SettingsMenu] = {
        categories: (_m = {},
            _m[MenuSettingsCategory.Settings] = {
                domComponent: TabSettings,
            },
            _m[MenuSettingsCategory.Blog] = {
                domComponent: TabBlog,
            },
            _m),
    },
    _a[IdMenuBalancing.ThemedEvent] = {
        categories: (_o = {},
            _o[ThemedEventCateogry.Event] = {
                domComponent: TabThemedEvent,
            },
            _o),
    },
    _a[IdMenuBalancing.Library] = {
        categories: (_p = {},
            _p[IdLibraryCategory.MainFarm] = {
                domComponent: TabFarm,
            },
            _p[IdLibraryCategory.Upgrade] = {
                domComponent: UpgradeLibrary,
            },
            _p),
    },
    _a[IdMenuBalancing.CoopMenu] = {
        categories: (_q = {},
            _q[IdCoopCategory.CoopInfoView] = {
                domComponent: TabCoopInfoView,
            },
            _q[IdCoopCategory.CoopSearch] = {
                domComponent: TabCoopSearch,
            },
            _q[IdCoopCategory.CoopEdit] = {
                domComponent: TabCoopFoundEdit,
            },
            _q[IdCoopCategory.CoopFound] = {
                domComponent: TabCoopFoundEdit,
            },
            _q[IdCoopCategory.CoopChat] = {
                domComponent: TabCoopChat,
            },
            _q[IdCoopCategory.CoopHelp] = {
                domComponent: TabCoopHelp,
            },
            _q[IdCoopCategory.CoopProjects] = {
                domComponent: TabCoopProjects,
            },
            _q[IdCoopCategory.CoopMessageBoard] = {
                domComponent: TabCoopMessageBoard,
            },
            _q),
    },
    _a[IdMenuBalancing.Store] = {
        categories: (_r = {},
            _r[IdStoreCategory.FarmDollarPackages] = {
                domComponent: TabStoreItems,
                footerResources: [IdResource.Money, IdResource.Gold],
            },
            _r[IdStoreCategory.LoyaltyPackages] = {
                domComponent: TabStoreItems,
                footerResources: [IdResource.LoyaltyPoints],
            },
            _r[IdStoreCategory.MysteryChests] = {
                domComponent: TabStoreItems,
                footerResources: [
                    IdResource.Snippets,
                    IdResource.TournamentCoins,
                    IdResource.ChestKeys,
                    IdResource.VictoryCoins,
                ],
            },
            _r[IdStoreCategory.TournamentPackages] = {
                domComponent: TabStoreItems,
                footerResources: [IdResource.TournamentCoins],
            },
            _r[IdStoreCategory.TreatShop] = {
                domComponent: TabStoreItems,
                footerResources: [IdResource.Money, IdResource.Gold],
            },
            _r),
    },
    _a[IdMenuBalancing.ExternalBarn] = {
        categories: (_s = {},
            _s[IdExternalBarnCategory.Upgrade] = {
                domComponent: TabUpgradeExternalBarn,
            },
            _s),
    },
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/features/menus/menuTabs.ts
// module id = 437
// module chunks = 3